import { render, staticRenderFns } from "./Banner5.vue?vue&type=template&id=254da985&scoped=true&"
import script from "./Banner5.vue?vue&type=script&lang=js&"
export * from "./Banner5.vue?vue&type=script&lang=js&"
import style0 from "./Banner5.vue?vue&type=style&index=0&id=254da985&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254da985",
  null
  
)

export default component.exports